// extracted by mini-css-extract-plugin
export default {"headStats":"head-stats_headStats__iIlCR","title":"head-stats_title__gMF7A","content":"head-stats_content__LmwFg"};